var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"loader-container"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader__bar"}),_c('div',{staticClass:"loader__bar"}),_c('div',{staticClass:"loader__bar"}),_c('div',{staticClass:"loader__bar"}),_c('div',{staticClass:"loader__bar"}),_c('div',{staticClass:"loader__ball"})])
}]

export { render, staticRenderFns }